<template>
  <div>
    <v-dialog v-model="is_generate_invoice_for_generate_invoice" max-width="800" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline">Invoice</v-card-title>
        <v-card-text class>
          <v-data-table
            class="elevation-1 mt-1 rounded-0 my-transaction-table"
            :items="items"
            hide-default-footer
            mobile-breakpoint="50"
            dense
          >
            <template v-slot:body.prepend>
              <tr class="header-background right-border-white">
                <td width="10%" class="text-center">
                  Item
                  <br />No.
                </td>
                <td width="30%" class="text-center">Group Name</td>
                <td width="30%" class="text-right">Group Value</td>
                <td width="30%" class="text-right">Transaction Value</td>
                <!-- <td width="10%" class="text-right">Balance</td> -->
              </tr>
            </template>
            <template v-slot:item="{ item, index}">
              <tr class="right-border-grey">
                <td width="10%" style="text-align:center;">{{index+1}}</td>
                <td width="30%" style="text-align:center;">{{item.group_name}}</td>
                <td width="30%" style="text-align:right;">${{item.total_group_amount.toFixed(2)}}</td>
                <td width="30%" style="text-align:right;">
                  ${{item.current_amount ? item.current_amount.toFixed(2) : 0}}
                  <v-icon @click="changeTranAmtDialog(item)">mdi-border-color</v-icon>
                </td>
                <!-- <td
                  width="10%"
                  style="text-align:right;"
                  :class="item.balance_amount < 0 ? 'error--text' : ''"
                >${{item.balance_amount ? getAmountFormat(item.balance_amount) : 0}} </td>-->
              </tr>
            </template>

            <template v-slot:body.append>
              <tr class="grey-lighten-background right-border-grey">
                <td width="10%"></td>
                <td width="30%" style="text-align:center;">Total</td>
                <td width="30%" style="text-align:right;">${{total_amt}}</td>
                <td width="30%" style="text-align:right;">
                  <span style="margin-right:25px">${{total_current_amount}}</span>
                </td>
                <!-- <td
                  width="10%"
                  style="text-align:right;"
                  :class="total_balance_amount < 0 ? 'error--text' :''"
                >${{getAmountFormat(total_balance_amount)}}</td>-->
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="$emit('closeDialog')" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            color="primary"
            class="pr-3 text-capitalize"
            @click="generateInvoice()"
          >{{is_update_invoice ? 'Update Invoice' : 'Save Invoice' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="change_tran_amt_dialog" max-width="1200" persistent>
      <v-card :loading="generate_invoice_loading">
        <v-card-title class="headline">Update Invoice Amount</v-card-title>
        <v-card-text class>
          <v-simple-table dense>
            <thead style="background: #455a64;">
              <tr>
                <td width="10%" class="white--text">Bank</td>
                <td width="10%" class="white--text">Date</td>
                <td width="12%" class="white--text text-right">Amount</td>
                <td width="12%" class="white--text">Vendor</td>
                <td width="16%" class="white--text">INV Amt</td>
                <td width="40%" class="white--text">Description</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in trans_items" :key="index" class="mt-3">
                <td>{{row.bank_id ? row.bank.bank_code : '' }}</td>
                <td>{{ getFormatedDate(row.trans_date) }}</td>
                <td class="text-right">
                  <div>
                    <span
                      :class="{
                        'error--text': row.rev_amount < 0,
                        'primary--text': row.rev_amount > 0,
                      }"
                    >${{ getAmountFormat(row.rev_amount) }}</span>
                  </div>
                </td>
                <td>
                  <v-tooltip bottom v-if="row.expence">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >{{ (row.expance_details)?row.expance_details.bank_code:'' }}</span>
                    </template>
                    <span>{{ (row.expance_details)?row.expance_details.bank_name:'' }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ (row.vendor)?row.vendor.v_code:'' }}</span>
                    </template>
                    <span>{{ (row.vendor)?row.vendor.v_name:'' }}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-text-field
                    style="margin-top: -2px;"
                    v-model="row.inv_amt"
                    type="number"
                    dense
                    hide-details
                    @input="getTotalUpdatevalue()"
                  ></v-text-field>
                </td>
                <td>
                  <div>
                    <v-tooltip left max-width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                          class="d-inline-block"
                          style="word-break: break-all;"
                          v-html="row.description.substring(0,40)"
                        >
                          <span v-if="row.description.length > 40">..</span>
                        </span>
                      </template>
                      <span>{{ row.description }}</span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
              <tr class="grey-lighten-background right-border-grey">
                <td></td>
                <td></td>
                <td></td>
                <td>Total</td>
                <td>${{parseFloat(this.updated_amt_total).toFixed(2)}}</td>
                <td></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="change_tran_amt_dialog = false"
            :disabled="generate_invoice_loading"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="generate_invoice_loading"
            color="primary"
            class="pr-3 text-capitalize"
            @click="updateInvoiceAmt()"
          >Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import moment from "moment";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      loading: false,
      generate_invoice_loading: false,
      items: [],
      trans_items: [],
      selected_group: {},
      total_amt: "",
      total_previous_amount: "",
      change_tran_amt_dialog: false,
      updated_amt_total: 0,
      last_match_balance_value: ""
    };
  },
  props: [
    "is_generate_invoice_for_generate_invoice",
    "project_details",
    "selected_rows",
    "is_update_invoice",
    "generate_invoice_id"
  ],
  watch: {
    is_generate_invoice_for_generate_invoice: function(value) {
      if (value) {
        this.selected_rows = this.selected_rows.filter(item => {
          if (item.invoice_amt) {
            item.inv_amt = item.invoice_amt;
          } else {
            item.inv_amt = parseFloat(this.getInvoiceAmt(item)).toFixed(2);
          }
          return item;
        });
        let project_data_flag = "";
        if (this.project_details.project_work.length > 0) {
          if (this.project_details.project_work == "remodeling") {
            project_data_flag = 2;
          } else if (this.project_details.project_work == "new_construction") {
            project_data_flag = 1;
          } else if (
            this.project_details.project_work == "project_management"
          ) {
            project_data_flag = 4;
          } else if (this.project_details.project_work == "retail_sales") {
            project_data_flag = 5;
          }
        }
        this.loading = true;
        axios
          .get(
            "get_item_group?project_id=" +
              this.project_details.project_id +
              "&project_data_flag=" +
              project_data_flag +
              "&is_update_invoice=" +
              this.is_update_invoice +
              "&generate_invoice_id=" +
              this.generate_invoice_id
          )
          .then(response => {
            let response_data = response.data;
            this.items = response_data.data;
            this.total_amt = response_data.total_amt;
            console.log(" this.items", this.items);
            this.items.filter(item2 => {
              let current_amount = 0;
              this.selected_rows.filter(item3 => {
                if (item3.invoice_group_id == item2.invoice_group_id) {
                  current_amount += parseFloat(item3.inv_amt);
                }
                item2.current_amount = current_amount;
                item2.balance_amount = parseFloat(
                  this.getBalanceAmount(item2)
                ).toFixed(2);
              });
            });
            this.loading = false;
          })
          .catch(function(error) {
            console.log(error);
            this.loading = false;
          });
      }
    }
  },
  computed: {
    total_current_amount() {
      let total = 0;
      this.items.filter(item => {
        total += item.current_amount;
      });
      return parseFloat(total).toFixed(2);
    },
    total_balance_amount() {
      let total = 0;
      this.items.filter(item => {
        total += this.getBalanceAmount(item);
      });
      return parseFloat(total).toFixed(2);
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    getTotalUpdatevalue() {
      var total = 0;
      this.trans_items.filter(item2 => {
        total += item2.inv_amt ? parseFloat(item2.inv_amt) : 0;
      });
      this.updated_amt_total = parseFloat(total).toFixed(2);
    },
    generateInvoice() {
      this.generate_invoice_loading = true;
      axios
        .post("generate_invoice", {
          selected_rows: this.selected_rows,
          project_details: this.project_details,
          is_update_invoice: this.is_update_invoice,
          generate_invoice_id: this.generate_invoice_id
        })
        .then(res => {
          this.setAlert({
            show: true,
            variant: "primary",
            message: res.data.message,
            dismissCountDown: 0
          });
          this.generate_invoice_loading = false;
          this.$emit("successGenerateInvoice");
          this.$emit("closeDialog");
        })
        .catch(() => {
          this.generate_invoice_loading = false;
        });
    },
    updateInvoiceAmt() {
      let total = 0;
      this.selected_rows = this.selected_rows.filter(item => {
        this.trans_items.filter(item2 => {
          if (item2.trans_id == item.trans_id) {
            item.inv_amt = item2.inv_amt;
            total += parseFloat(item.inv_amt);
          }
        });
        return item;
      });
      let id = this.selected_group.invoice_group_id;
      this.items = this.items.filter(item => {
        if (item.invoice_group_id == id) {
          item.current_amount = total;
        }

        item.balance_amount = parseFloat(this.getBalanceAmount(item)).toFixed(
          2
        );
        return item;
      });

      this.change_tran_amt_dialog = false;
    },
    getBalanceAmount(item) {
      console.log("item.total_group_amount", item.total_group_amount);
      console.log("item.current_amount", item.current_amount);
      console.log(
        "item.total_group_amount",
        parseFloat(item.total_group_amount) - parseFloat(item.current_amount)
      );
      return (
        parseFloat(item.total_group_amount) - parseFloat(item.current_amount)
      );
    },

    changeTranAmtDialog(item) {
      this.selected_group = item;
      this.updated_current_amount = item.current_amount;
      this.last_match_balance_value =
        parseFloat(item.total_group_amount) -
        parseFloat(item.current_amount) -
        parseFloat(item.previous_amount);
      this.trans_items = this.selected_rows.filter(item2 => {
        if (item2.invoice_group_id == item.invoice_group_id) {
          return item;
        }
      });
      console.log("this.trans_items", this.trans_items);
      var total = 0;
      this.trans_items.filter(item3 => {
        total += parseFloat(item3.inv_amt);
      });
      this.updated_amt_total = total;
      this.change_tran_amt_dialog = true;
    },
    getInvoiceAmt(item) {
      let total = this.getAmountFormat(item.rev_amount);
      return parseFloat(total).toFixed(2);
    },
    getAmountFormat(value) {
      if (value) {
        return value.toString().replace("-", "");
      } else {
        return 0;
      }
    },
    getFormatedDate(date) {
      return moment(date).format("MM/DD/YY");
    }
  }
};
</script>